const WORKSPACE_DEFINITIONS = [
    {
        id: 'technical-service',
        label: 'Technical Service',
        tabs: [
            { id: 'repair-orders', label: 'Repair Orders', route: '/repair-orders', access: ({ canSeeRepairOrders }) => canSeeRepairOrders },
            {
                id: 'preventive-maintenance',
                label: 'Preventive Maintenance',
                route: '/preventive-maintenance',
                access: ({ canSeePreventiveMaintenance }) => canSeePreventiveMaintenance
            },
            {
                id: 'machine-movements',
                label: 'Machine Movements',
                route: '/machine-movements',
                access: ({ canSeeMachineMovements }) => canSeeMachineMovements
            },
            { id: 'parts-inventory', label: 'Parts Inventory', route: '/parts-inventory', access: ({ canSeePartsInventory }) => canSeePartsInventory }
        ]
    },
    {
        id: 'complaints',
        label: 'Complain Management',
        tabs: [
            { id: 'open-complaints', label: 'Open Complaints', route: '/open-complaints', access: ({ canSeeOpenComplaints }) => canSeeOpenComplaints },
            {
                id: 'refund-queue',
                label: 'Refund Queue',
                route: '/refund-queue',
                access: ({ canSeeRefundQueueInComplaints, canSeeStandaloneRefundQueue }) =>
                    canSeeRefundQueueInComplaints || canSeeStandaloneRefundQueue
            },
            { id: 'call-history', label: 'Call History', route: '/call-history', access: ({ canSeeCallHistory }) => canSeeCallHistory },
            { id: 'close-complaints', label: 'Close Complaints', route: '/close-complaints', access: ({ canSeeCloseComplaints }) => canSeeCloseComplaints }
        ]
    },
    {
        id: 'machine-platforms',
        label: 'Machine Platforms',
        tabs: [
            { id: 'parlevel-overview', label: 'Overview', route: '/parlevel', access: ({ canAccessParlevelOverview }) => canAccessParlevelOverview },
            {
                id: 'parlevel-route-planning',
                label: 'Route Planning',
                route: '/parlevel/routes',
                access: ({ canAccessParlevelRoutePlanning }) => canAccessParlevelRoutePlanning
            },
            {
                id: 'parlevel-coin-tubes',
                label: 'Coin Tubes',
                route: '/parlevel/change-levels',
                access: ({ canAccessParlevelChangeLevels }) => canAccessParlevelChangeLevels
            },
            { id: 'parlevel-data-sync', label: 'Data & Sync', route: '/parlevel/data', access: ({ canAccessParlevelData }) => canAccessParlevelData },
            { id: 'jetinno', label: 'Jetinno', route: '/jetinno', access: ({ canAccessJetinno }) => canAccessJetinno }
        ]
    }
];

const routeMatches = (pathname, route) => pathname === route || pathname.startsWith(`${route}/`);

export const buildWorkspaceTabs = (pathname, access, translate = (value) => value) => {
    const workspace = WORKSPACE_DEFINITIONS.find((candidate) => candidate.tabs.some((tab) => routeMatches(pathname, tab.route)));
    if (!workspace) return null;

    const visibleTabs = workspace.tabs.filter((tab) => tab.access(access));
    if (visibleTabs.length < 2) return null;

    const activeTab = visibleTabs
        .filter((tab) => routeMatches(pathname, tab.route))
        .sort((first, second) => second.route.length - first.route.length)[0];

    return {
        id: workspace.id,
        label: translate(workspace.label),
        activeId: activeTab?.id || null,
        tabs: visibleTabs.map((tab) => ({ ...tab, label: translate(tab.label) }))
    };
};

export { WORKSPACE_DEFINITIONS };
